import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { userPermissionsResponseSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = {
  queryKey: [API_ENDPOINTS.USER_PERMISSIONS],
  queryFn: () =>
    get(API_ENDPOINTS.USER_PERMISSIONS, userPermissionsResponseSchema),
}

export const useAPIGetUserPermissionsSuspense = () => useSuspenseQuery(params)

export const useAPIGetUserPermissions = () => useQuery(params)
